import { render, staticRenderFns } from "./ContentMenu.vue?vue&type=template&id=c0ac3890&scoped=true&shadow"
import script from "./ContentMenu.vue?vue&type=script&lang=js&shadow"
export * from "./ContentMenu.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./ContentMenu.vue?vue&type=style&index=0&id=c0ac3890&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c0ac3890",
  null
  ,true
)

export default component.exports